
import { getDownloadURL, ref as storageRef, getStorage } from "@firebase/storage";
import { defineComponent } from "vue";

export default defineComponent({
  props: ['logs'],
  methods: {
    downloadLogFile(fullPath: string) {
      getDownloadURL(storageRef(getStorage(), fullPath)).then(
        (link) => window.open(link, "Download")
      );
    },
  },
});
